import React, { useEffect, useState } from 'react';
import '../component.scss';
import SearchDropdownVirtualizedList from './SearchDropdownVirtualizedList';
import RegionDropdownMultiselectOpenList from './RegionDropdownMultiselectOpenList';

const RegionsWidgetOpen = ({
  value,
  subvalue = [],
  items = [],
  label,
  title = '',
  width = 220,
  type = 'base',
  onChoose,
  onSubChoose,
}) => {
  const [wasChanged, setWasChanged] = useState(false);

  const setValue = (value, sub = false) => {
    if (sub) {
      onSubChoose(sub);
    } else {
      onChoose(value);
    }
  };

  useEffect(() => {
    if (value.length > 0 || subvalue.length > 0) {
      setWasChanged(true);
    } else setWasChanged(false)
  }, [value, subvalue])

  const reset = () => {
    setValue([]);
  };

  return (
    <div
      className={`search-widget-open ${wasChanged}`}
      style={{ width: width, marginLeft: '0px', position: 'relative' }}
    >
      <div
        style={{
          top: '-17px',
          color: '#777',
          textTransform: 'uppercase',
          fontSize: '10px',
          marginLeft: '10px',
        }}
      >
        {label}
      </div>
      <div
        style={{
          position: 'absolute',
          left: '70px',
          top: '0px',
          color: '#3e6a3a',
          textTransform: 'uppercase',
          fontSize: '10px',
          fontWeight: 700,
        }}
      >
        {title}
      </div>
      <div className="search-widget-open__wrap" style={{ width: '100%' }}>
        {type === 'multiselect' && (
          <RegionDropdownMultiselectOpenList
            subvalue={subvalue}
            value={value}
            depth={true}
            items={items}
            onChoose={setValue}
          />
        )}
        {type === 'virtualized' && (
          <SearchDropdownVirtualizedList
            value={value}
            items={items}
            onChoose={setValue}
          />
        )}
      </div>
    </div>
  );
};

export default RegionsWidgetOpen;
